import { TwoN4uAdProvider } from './providers/TwoN4uAdProvider'
import type { AdProvider } from './types'

/**
 * Single application-level provider selection point.
 *
 * Future Google integration belongs here (for example a GoogleAdProvider that
 * implements AdProvider). Screen components should not import provider SDKs.
 */
let singleton: AdProvider | null = null

export function getAdProvider(): AdProvider {
  if (singleton) return singleton

  const requested = (import.meta.env.VITE_AD_PROVIDER ?? '2n4u').trim().toLowerCase()
  if (requested !== '2n4u') {
    // Fail closed: never silently load an unknown advertising provider.
    throw new Error(`Unsupported ad provider: ${requested}`)
  }

  singleton = new TwoN4uAdProvider()
  return singleton
}
